// Search routines
import $ from 'jquery';
import * as Site from "../js/site";
import * as Constants from "./constants";
import * as Plans from "../js/plans";

let EsriModules;
let mapView;
let idParams, parcelIdTask;
let findParams, findParcelTask;

let processSelectedParcelData;

let planSearchCount = 0;
let apnMatchList = [];
let addressMatchList = [];

export const initSearch = (em, pspd) => {
  // console.log("Search->initSearch");
  //****For testing****
  // $("#main-apn-input").val("2580904300");
  // $("#main-address-input").val("505 S Vulcan Ave");
  //************
  EsriModules = em;
  processSelectedParcelData = pspd;

  mapView = EsriModules.mapView;

  idParams = new EsriModules.IdentifyParameters({
    tolerance: 3,
    width: mapView.width,
    height: mapView.height
  });
  parcelIdTask = new EsriModules.IdentifyTask(Constants.basemapUrl);

  findParams = new EsriModules.FindParameters();
  findParams.contains = true;
  findParams.returnGeometry = true;
  findParams.layerIds = [8];
  findParcelTask = new EsriModules.FindTask(Constants.basemapUrl);

  $("#main-search-apn-match-0").click(function () { parcelApnSelected(0); });
  $("#main-search-apn-match-1").click(function () { parcelApnSelected(1); });
  $("#main-search-apn-match-2").click(function () { parcelApnSelected(2); });
  $("#main-search-apn-match-3").click(function () { parcelApnSelected(3); });
  $("#main-search-apn-match-4").click(function () { parcelApnSelected(4); });

  $("#main-search-address-match-0").click(function () { parcelAddressSelected(0); });
  $("#main-search-address-match-1").click(function () { parcelAddressSelected(1); });
  $("#main-search-address-match-2").click(function () { parcelAddressSelected(2); });
  $("#main-search-address-match-3").click(function () { parcelAddressSelected(3); });
  $("#main-search-address-match-4").click(function () { parcelAddressSelected(4); });
}

export const identifyParcel = (event, geoPoint) => {
  if (geoPoint) {
    idParams.geometry = geoPoint;
    //idParams.mapExtent = mapView.map.layers.items[0].fullExtent;
    let dist = 1000;
    idParams.mapExtent = new EsriModules.Extent({
      xmin: geoPoint.x - dist,
      xmax: geoPoint.x + dist,
      ymin: geoPoint.y - dist,
      ymax: geoPoint.y + dist,
      spatialReference: new EsriModules.SpatialReference(3857)
    });
  } else {
    idParams.geometry = event.mapPoint;
    idParams.mapExtent = mapView.extent;
  }
  idParams.layerIds = [8];
  idParams.layerOption = "all"; // Parcel layer has visibility threshold. Override it.
  idParams.returnGeometry = true;

  planSearchCount = 0;
  parcelIdTask.execute(idParams)
    .then(function (response) {
      let results = response.results;
      if (results.length === 0) {
        processSelectedParcelData(null, idParams.geometry);
      } else {
        processSelectedParcelData(results[0].feature, null);
      }
      planSearchCount++;
    })
    .catch(function (error) {
      Site.displayError("#map-left", "Parcel identify error: " + error.message);
      console.log("Parcel identify error: ", error.message);
    });

  identifyFabricParcel(idParams);
}

function identifyFabricParcel(idp) {
  let idParams = new EsriModules.IdentifyParameters({
    tolerance: 3,
    width: mapView.width,
    height: mapView.height
  });
  idParams.geometry = idp.geometry;
  idParams.mapExtent = idp.mapExtent;
  idParams.layerIds = [5];
  idParams.layerOption = "all"; // Parcel layer has visibility threshold. Override it.
  idParams.returnGeometry = true;

  let parcelIdTask = new EsriModules.IdentifyTask(Constants.landRecordsUrl);
  parcelIdTask.execute(idParams)
    .then(function (response) {
      let results = response.results;
      if (results.length === 0) {
        $("#map-land-records").hide();
        $("#map-land-no-records").show();
        $("#map-land-container").show();
        Site.displayError("#map-left", "No fabric parcels found at that location?");
        return;
      }
      Plans.processParcelPlans(results);
    })
    .catch(function (error) {
      Site.displayError("#map-left", "Fabric parcel identify error: " + error.message);
      console.log("Fabric parcel identify error: ", error.message);
    });
}

export const findApn = () => {
  let apn = $.trim($("#main-apn-input").val());
  if (apn === "") return;

  findParams.searchFields = ["APN"];
  findParams.searchText = apn;
  Site.displayMessage("#main-search-parcel", "Searching for parcel...");
  // console.log("Searching for : " + findParams.searchText);

  findParcelTask.execute(findParams)
    .then(function (response) {
      let results = response.results;
      if (results.length === 0) {
        $("#map-land-container").hide();
        $("#map-parcel-container").hide();
        $("#map-left-instructions").show();
        Site.displayError("#map-left", "Parcel number not found.");
        Site.displayError("#main-search-parcel", "Parcel number not found.");
        return;
      }

      apnMatchList.length = 0;
      if (results.length === 1) {
        apnMatchList.push(results[0].feature);
        parcelApnSelected(0);
      } else {
        let numResults = results.length;
        for (let idx = 0; idx < 5; idx++) {
          if (idx < numResults) {
            apnMatchList.push(results[idx].feature);
            let attr = results[idx].feature.attributes;
            let addr = attr.SitusStreet === "Null" ? "" : attr.SitusStreet;
            $("#main-search-apn-match-" + idx).html("APN: " + attr.APN + "<br/>Address: " + addr);
            $("#main-search-apn-match-" + idx).show();
          } else {
            $("#main-search-apn-match-" + idx).hide();
          }
        }
        Site.hideInfo("#main-search-parcel");
        $("#main-search-apn-multiple-match").show();

        $("#map-land-container").hide();
        $("#map-parcel-container").hide();
        $("#map-left-instructions").show();
      }
    })
    .catch(function (error) {
      Site.displayError("#main-search-parcel", "Find parcel error: " + error.message);
      $("#map-parcel-container").hide();
      $("#map-left-instructions").show();
      console.log("Find parcel error: ", error.message);
    });
}

export const findAddress = () => {
  let addr = $.trim($("#main-address-input").val());
  if (addr === "") return;

  let locator = new EsriModules.Locator();
  locator.url = Constants.locatorUrl;
  locator.outSpatialReference = new EsriModules.SpatialReference(3857);
  // let address = {
  //   address: {
  //     Street: addr //"505 s vulcan"
  //   }
  // };
  let address = {
    address: {
      address: addr //"505 s vulcan"
    }
  };
  locator.addressToLocations(address)
    .then(function (response) {
      addressMatchList.length = 0;
      switch (response.length) {
        case 0:
          Site.displayError("#main-search-parcel", "Address not found.");
          $("#map-land-container").hide();
          $("#map-parcel-container").hide();
          $("#map-left-instructions").show();
          return;
        case 1:
          Site.displayMessage("#main-search-parcel", "Address found.<br/>" + response[0].address);
          addressMatchList.push(response[0].location);
          parcelAddressSelected(0);
          break;
        case 2:
          let idxToUse = -1;
          if (response[0].address.slice(-2) === "MP") {
            idxToUse = 1;
          }
          if (response[1].address.slice(-2) === "MP") {
            if (idxToUse === -1) {
              idxToUse = 0;
            } else {
              idxToUse = -1; // Both have MP so let user decide
            }
          }
          if (idxToUse > -1) {
            Site.displayMessage("#main-search-parcel", "Address found.<br/>" + response[idxToUse].address);
            addressMatchList.push(response[idxToUse].location);
            parcelAddressSelected(0);
            break;
          }
        default:
          let numResponses = response.length;
          for (let idx = 0; idx < 5; idx++) {
            if (idx < numResponses) {
              addressMatchList.push(response[idx].location);
              $("#main-search-address-match-" + idx).html("Score: " + response[idx].score + "<br/>Address: " + response[idx].address);
              $("#main-search-address-match-" + idx).show();
            } else {
              $("#main-search-address-match-" + idx).hide();
            }
          }
          Site.hideInfo("#main-search-parcel");
          $("#main-search-address-multiple-match").show();

          $("#map-land-container").hide();
          $("#map-parcel-container").hide();
          $("#map-left-instructions").show();
          return;
      }
    }).catch(function (error) {
      Site.displayError("#main-search-parcel", "Find parcel error: " + error.message);
      $("#map-land-container").hide();
      $("#map-parcel-container").hide();
      $("#map-left-instructions").show();
      console.log("Find parcel error: ", error.message);
    });
}

function parcelApnSelected(idx) {
  Site.hideInfo("#main-search-parcel");

  $("#map-land-container").hide();
  $("#map-parcel-container").hide();
  $("#map-left-instructions").hide();
  $("#header-right-toolbar-print").hide();

  Site.toggleParcelSearchContainer();

  let point = apnMatchList[idx].geometry.centroid;
  identifyParcel(null, point);

  // processSelectedParcelData(apnMatchList[idx], null);
}

function parcelAddressSelected(idx) {
  $("#map-land-container").hide();
  $("#map-parcel-container").hide();
  $("#map-left-instructions").hide();
  $("#header-right-toolbar-print").hide();

  Site.toggleParcelSearchContainer();

  let point = new EsriModules.Point({
    x: addressMatchList[idx].x,
    y: addressMatchList[idx].y,
    spatialReference: new EsriModules.SpatialReference(3857)
  });

  identifyParcel(null, point);
}

export function buildParcelHtml(attr) {
  let addr = attr.SitusStreet === "Null" ? "" : attr.SitusStreet;
  $("#map-parcel-apn").html(attr.APN);
  $("#map-parcel-address").html(addr);
}
